import { theme } from '@provi/provi-components'
import styled from 'styled-components'

export const Container = styled.div`
  display: ${({ show }) => (show ? 'block' : 'none')};
  width: 90%;
  padding: 0 25px 0 130px;

  @media (max-width: 800px) {
    padding: 0 25px;
    width: 84%;
  }
`

export const Title = styled.p`
  width: 100%;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 26px;
  line-height: 36px;
  color: ${theme.colors.black100};

  @media (max-width: 800px) {
    font-size: 22px;
    line-height: 32px;
  }
`

export const Subtitle = styled.p`
  width: 100%;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  max-width: 600px;
  color: ${theme.colors.black100};

  @media (max-width: 800px) {
    font-size: 14px;
    line-height: 24px;
  }
`

export const Sublink = styled.a`
  text-decoration: none;
  color: ${theme.colors.bluePrimary};
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;

  @media (max-width: 800px) {
    margin: 30px auto;
  }
`

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.colors.bluePrimary};
  color: ${theme.colors.white100};
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  padding: 15px 20px;
  margin-left: 30px;
  border: none; /* Added to reset default button border */
  border-radius: 4px;
  cursor: pointer;

  :hover {
    background: ${theme.colors.blueSecundaryDark};
  }

  :active {
    background: ${theme.colors.bluePrimaryDark};
  }

  & > svg {
    margin-left: 10px;
  }

  @media (max-width: 800px) {
    width: 84%;
    margin-top: 20px;
    margin-left: 0; /* Ensures it centers nicely on mobile */
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  max-width: 99vw;

  @media (max-width: 800px) {
    flex-direction: column-reverse;
    align-items: end;
  }
`

export const BorderBottom = styled.div`
  border-bottom: 1px solid #cfcfcf;
  width: 100%;
  height: 1px;
  margin-top: 30px;

  @media (max-width: 800px) {
    margin-top: 0px;
  }
`

export const ButtonUpgrade = styled.button`
  margin: 20px 0;
  height: 48px;
  width: 192px;
  cursor: pointer;
  background: ${theme.colors.bluePrimary};
  border-radius: 4px;
  border: none; /* Added to reset default button border */
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 13.2px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.005em;
  color: ${theme.colors.white100};
  flex: none;
  order: 0;
  flex-grow: 0;

  @media (max-width: 800px) {
    width: 100%;
  }
`
